module.exports = __webpack_public_path__ + "static/media/icono_bar_menu-mobile.6c8f9aff.webp";